var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47059 0H16V5.64706H8.47059V0ZM8.47059 16V6.58824H16V16H8.47059ZM0 16V10.3529H7.52941V16H0ZM0 9.41177V0H7.52941V9.41177H0ZM0.8 0.8V8.8H6.8V0.8H0.8ZM9.2 0.8V4.8H15.2V0.8H9.2ZM9.2 7.2V15.2H15.2V7.2H9.2ZM0.8 11.2V15.2H6.8V11.2H0.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group-5.e78cfac0ef7cef8ef0dfc1f753be6780.svg";
export { ForwardRef as ReactComponent };